import { render, staticRenderFns } from "./fiindex.vue?vue&type=template&id=418ff3cc&scoped=true&"
import script from "./fiindex.vue?vue&type=script&lang=js&"
export * from "./fiindex.vue?vue&type=script&lang=js&"
import style0 from "./fiindex.vue?vue&type=style&index=0&id=418ff3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ff3cc",
  null
  
)

export default component.exports